import { type ContentComponent, type SupportMenuSectionContent, type SupportMenuLinkContent } from '../../../../types/construct.types';
import { StyledLink } from '../../../common-components/link/styled-link.component';
import { PanelComponent } from '../../../common-components/panel-component/panel-component.component';

export const SupportMenuSection: ContentComponent<SupportMenuSectionContent> = ({ content, renderer }) => {
	return (
		<PanelComponent headingContent={content.fields.heading} className={'f6'}>
			<>{renderer.render(content.fields.sectionItems)}</>
		</PanelComponent>
	);
};

export const SupportMenuLink: ContentComponent<SupportMenuLinkContent> = ({ content }) => {
	return (
		<StyledLink color="grey-darker" url={content.fields.cta_url.linkUrl} className="w-100" underlineHover={true}>
			{content.fields.cta}
		</StyledLink>
	);
};
